module.exports = __webpack_public_path__ + "static/media/icon_level.8a236588.svg";